import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addressPipe',
})
export class AddressPipePipe implements PipeTransform {
  transform(value): string {
    if (value && value.line1) {
      let addr = `${value.line1}, ${value.city}`;
      addr = value.provinceCode ? addr + `, ${value.provinceCode}` : addr;
      addr = value.postalCode ? addr + ` ${value.postalCode}` : addr;
      return addr;
    }
    return '';
  }
}
